import moment from 'moment-timezone';
import momentDurationFt from 'moment-duration-format';

momentDurationFt(moment);

export const formatDate = (date) => {
  if (typeof date !== 'string') {
    return moment(date).format('MMM DD, YYYY');
  }

  return date;
};

export const extractDate = (dateString, format = null) => {
  // Ensure dateString is a string
  let date = typeof dateString === 'string' ? dateString.split('T')[0] : dateString;

  // Parse the date string or object as a Moment.js object
  let momentDate = moment(date);

  // If a format is provided, return the formatted date string
  if (format) {
      return momentDate.format(format);
  }

  // Otherwise, return the Moment.js object
  return momentDate;
}

export const calcDuration = (start, end) => moment(end).diff(moment(start), 'minutes');

export const isAllDay = (start, end) => {
  const duration = calcDuration(start, end);
  if (moment(start).format('hh:mm a') === moment().startOf('day').format('hh:mm a') && duration === 1440) {
    return true;
  }
  return false;
};

export const disableDate = day => moment(day).isAfter(moment());

export const defaultDate = () => moment().subtract(1, 'day').toDate();

export const getOffset = tz => moment.tz(tz).utcOffset();

export const absDiff = (_date1, _date2) => {
  const date1 = moment(_date1);
  const date2 = moment(_date2);

  const offsetDiff = date2.utcOffset() - date1.utcOffset();

  return Math.abs(date2.diff(date1, 'minutes') + offsetDiff);
};

export const getElapsedTime = (start, end) => {
  const ms = moment(end).diff(moment(start));
  const d = moment.duration(ms);
  return d.format('hh:mm:ss', { trim: false });
};


export const convertTimeToUtc = (dateISOString, timeString, timeZone) => {
  if (!moment.tz.zone(timeZone)) {
    throw new Error(`Invalid timezone: ${timeZone}`);
  }

  // Parse the date and time in the given timezone
  const localDateTime = moment.tz(`${dateISOString} ${timeString}`, "YYYY-MM-DD hh:mm A", timeZone);

  // Convert to UTC
  const utcDateTime = localDateTime.clone().tz("UTC");


  return utcDateTime.format("YYYY-MM-DD HH:mm:ss+00");
};